import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { getErrorComponent, isStaticRender } from 'helpers/ContentHelper';
import Loader from 'components/Loader';
import { helperGoToVideoDetail } from 'helpers/RouteHelper';
import { fetchLatestEpisodeSeries, fetchLatestEpisodeVideo } from './LatestEpisodeActions';
import style from './LatestEpisode.css';

class LatestEpisode extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { accessToken, deviceId, fetchLatestEpisodeSeries, seriesScreenUrl, params } = this.props;
    if (isStaticRender()) return;
    const showId = _.get(params, 'showId');
    if (!seriesScreenUrl) fetchLatestEpisodeSeries(showId, accessToken, deviceId);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { fetchLatestEpisodeVideo, location } = this.props;
    const { accessToken, deviceId } = nextProps;
    const seriesScreenUrl = _.get(this.props, 'seriesScreenUrl');
    const nextSeriesScreenUrl = _.get(nextProps, 'seriesScreenUrl');
    const latestEpisodeId = _.get(this.props, 'latestEpisodeId');
    const nextLatestEpisodeId = _.get(nextProps, 'latestEpisodeId');

    if (!seriesScreenUrl && nextSeriesScreenUrl) {
      return fetchLatestEpisodeVideo(nextSeriesScreenUrl, accessToken, deviceId);
    }

    if (!latestEpisodeId && nextLatestEpisodeId) {
      const { search } = location;
      const hasQueryString = search && _.includes(search, '?');
      const trailingSlash = hasQueryString ? '/' : '';
      const url = `${nextLatestEpisodeId}${trailingSlash}${search}`;
      return helperGoToVideoDetail(url);
    }

    return null;
  }

  render() {
    const { errors } = this.props;
    if (errors) return getErrorComponent(errors);
    return (
      <div className={style.screen}>
        <Loader />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    seriesScreenUrl: state.latestEpisode.seriesScreenUrl,
    latestEpisodeId: state.latestEpisode.latestEpisodeId,
    errors: state.latestEpisode.errors,
  };
}

LatestEpisode.defaultProps = {
  accessToken: null,
  deviceId: null,
  errors: null,
  seriesScreenUrl: null,
};

LatestEpisode.propTypes = {
  accessToken: PropTypes.string,
  deviceId: PropTypes.string,
  errors: PropTypes.number,
  fetchLatestEpisodeSeries: PropTypes.func.isRequired,
  fetchLatestEpisodeVideo: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  params: PropTypes.shape({
    showId: PropTypes.string,
  }).isRequired,
  seriesScreenUrl: PropTypes.string,
};

export default connect(mapStateToProps, {
  fetchLatestEpisodeSeries,
  fetchLatestEpisodeVideo,
})(LatestEpisode);
